module.exports = __webpack_public_path__ + "images/emoji/rotating_light.ad782675a6d15afc8d83.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rotating_light.png
// module id = Z2vv
// module chunks = 13